import { useGetIdentity, useGetOne } from "ra-core";
import type { Sale } from "../types";

export const useCurrentSale = (): Sale | undefined => {
  const { identity, isLoading: identityLoading } = useGetIdentity();
  const { data: sale, isLoading: saleLoading } = useGetOne<Sale>(
    "sales",
    { id: identity?.id },
    { enabled: !identityLoading && !!identity?.id },
  );

  if (identityLoading || saleLoading) return undefined;
  return sale;
};
